// jshint esversion: 8

export default {
  all: state => state.data,
  saved: state => state.saved,
  byId: state => id => state.data.find(item => item.id === id),
  byName: state => name => state.data.find(item => item.name === name),
  getStandard: state => state.data.find(item => item.name.match(/^(standard)$/ig)), // matches exactly "standard" case insensitive
  getPeak: state => state.data.find(item => item.name.match(/^(peak)$/ig)), // matches exactly "peak" case insensitive
  getMisc: state => state.data.filter(
    item => item.name.match(/^(?!^standard$)(?!^peak$)(.*)$/ig)) // does not match "standard" or "peak" unless there is something before/after case insensitive
}
